import defaultProjectData from '../data/defaultProjectData'
import defaultAppData from '../data/defaultAppData'

const initialState = Object.assign({}, defaultAppData, { project: defaultProjectData })

export default initialState
